(function attachHoverMenu(){
  function bind() {
    // Solo desktop con mouse
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!desktop || !canHover) return;

    const details = document.querySelectorAll('.header__inline-menu details');

    details.forEach((det) => {
      const parent = det.closest('.header__menu-item') || det.parentElement;
      if (!parent) return;

      // Evita duplicar listeners
      if (parent.__aromicaHoverBound) return;
      parent.__aromicaHoverBound = true;

      parent.addEventListener('mouseenter', () => {
        det.setAttribute('open', '');
        // Quita [hidden] en submenús comunes de Dawn
        det.querySelectorAll('.mega-menu[hidden], .header__submenu[hidden], .list-menu--disclosure[hidden]')
          .forEach(el => el.removeAttribute('hidden'));
        const sum = det.querySelector('summary');
        if (sum) sum.setAttribute('aria-expanded','true');
      });

      parent.addEventListener('mouseleave', () => {
        det.removeAttribute('open');
        const sum = det.querySelector('summary');
        if (sum) sum.setAttribute('aria-expanded','false');
      });
    });
  }

  // Enlaza al cargar
  document.addEventListener('DOMContentLoaded', bind);
  // Shopify recarga secciones dinámicamente; vuelve a enlazar
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:reorder', bind);
  document.addEventListener('shopify:inspector:activate', bind);
})();
